



























import FieldModel from '@/UI/Shared/Mixins/FieldModel'
import mixins from 'vue-typed-mixins'

export default mixins(FieldModel).extend({
  name: 'StringifiedNumberInput',
  props: {
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      status: '',
      errorMessage: ''
    }
  },
  watch: {
    currentValue (newValue: string, oldValue: string) {
      if (newValue !== oldValue) {
        this.validateInput()
      }
    }
  },
  computed: {
    iconClass (): string {
      if (this.status === 'success') {
        return 'glyphicon-ok'
      }
      if (this.status === 'danger') {
        return 'glyphicon-remove'
      }
      return ''
    },
    statusMessage (): string {
      if (this.status === '') {
        return ''
      }
      return this.$t('shared.input.message.' + this.status).toString()
    },
    statusClass (): string {
      if (this.status === 'success') {
        return 'has-success has-feedback'
      }
      if (this.status === 'danger') {
        return 'has-error has-feedback'
      }
      return ''
    }
  },
  methods: {
    validateInput () {
      const value = this.currentValue + ''
      this.status = value !== ''
        ? 'success'
        : 'danger'
      this.emitValue(value)
    }
  }
})
